import React, {useEffect} from "react"
import {connect, useDispatch} from "react-redux"
import ShowDataList from "../../../../function/hooks/showDataList"
import Styles from "./leftNav.less"
import upPre from "../../../../static/pic/upPre.svg"
import downPre from "../../../../static/pic/downPre.svg"
import showListSvg from "../../../../static/pic/unfold.svg"
import returnSvg from "../../../../static/pic/return.svg"
import {changeScaleScal} from "../../../../action/dataAction"
import PreInput from "../../../../function/hooks/preInputValue"
import {VIEWTYPE} from "../../../util/utilData"
import {ReducerState} from "../../../../reducer/interface/baseInterface"
import {ComparisonStatus} from "../../../../reducer/interface/controlInterface"

const cssTitle = `TDA_LEFT_BOX_NAV`

interface LeftNavProps {
    loading: boolean
    scaleScal: number
    activeView: string
    viewType: string
    comparisonStatus: ComparisonStatus
}

const LeftNav: React.FunctionComponent<LeftNavProps> = (props) => {
    const dispatch = useDispatch()
    const preInput = PreInput()
    const showDataList = ShowDataList()
    useEffect(() => {
        if (props.loading === false) {
            preInput.init()
            dispatch(changeScaleScal(0.5))
        }
    }, [props.loading])
    const changePreValue = (e: any) => {
        preInput.changeValue(e.target.value)
    }
    const preKeyDown = (e: any) => {
        if (e.keyCode !== 13) {
            return
        }
        upDownPre(parseFloat(e.target.value) / 100)
    }
    const upDownPre = (value: number) => {
        let scaleScal = value
        if (scaleScal <= 0.1) {
            scaleScal = 0.1
        }
        if (scaleScal >= 1.5) {
            scaleScal = 1.5
        }
        preInput.changeValue(parseInt(`${scaleScal * 100}`))
        setTimeout(() => {
            dispatch(changeScaleScal(scaleScal))
        }, 200)
    }
    const showList = () => {
        if (props.comparisonStatus.status === "success") {
            showDataList.toTrue()
        }
    }
    return (
        <div className={Styles[`${cssTitle}`]}>
            <div className={Styles[`${cssTitle}_LEFT`]}>
                <img
                    onClick={() => {
                        dispatch({type: "returnOperate", payload: ""})
                        dispatch({type: "activeView", payload: "operate"})
                    }}
                    style={{display: props.viewType === VIEWTYPE.SHOW ? "none" : "flex"}}
                    className={Styles.returnStep}
                    src={returnSvg}
                    alt={""}
                />
                <div className={Styles[`${cssTitle}_BTNBOX`]}>
                    <img
                        alt={""}
                        src={downPre}
                        className={Styles.upDownBtn}
                        onClick={() => {
                            upDownPre((props.scaleScal * 10 - 0.1 * 10) / 10)
                        }}
                    />
                    <input
                        className={Styles.pre}
                        onChange={(e) => changePreValue(e)}
                        onKeyDown={(e) => preKeyDown(e)}
                        value={preInput.value}
                    />
                    <img
                        alt={""}
                        src={upPre}
                        className={Styles.upDownBtn}
                        onClick={() => {
                            upDownPre((props.scaleScal * 10 + 0.1 * 10) / 10)
                        }}
                    />
                </div>
                <div className={Styles[`${cssTitle}_COLORDESCAREA`]}>
                    <div className={Styles.insertColorBlock}>新增区域</div>
                    <div className={Styles.replaceColorBlock}>修改区域</div>
                    <div className={Styles.deleteColorBlock}>删除区域</div>
                </div>
            </div>
            <div className={Styles[`${cssTitle}_RIGHT`]}>
                <div
                    style={{
                        display: props.comparisonStatus.status === "success" && !showDataList.value ? "flex" : "none",
                    }}
                    className={Styles[`${cssTitle}_SHOWLISTBOX`]}
                >
                    <img
                        onClick={() => showList()}
                        alt={""}
                        style={{
                            width: "18px",
                            cursor: "pointer",
                        }}
                        src={showListSvg}
                    />
                </div>
            </div>
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        loading: state.control.loading,
        scaleScal: state.data.scaleScal,
        activeView: state.control.activeView,
        viewType: state.global.viewType,
        comparisonStatus: state.control.comparisonStatus,
    }
})(LeftNav)
